import { Outlet, useNavigate } from '@tanstack/react-router';
import { type ReactElement, useEffect } from 'react';

import { ForecastSessionGate } from 'src/features/forecastSessions/ForecastSessionGate';
import { useForecastSession } from 'src/features/forecastSessions/useForecastSession';
import { BrandSidebarWithHeader } from 'src/layouts/BrandSidebarWithHeader';
import { useBoundStore } from 'src/store/store';

function ForecastPageContent(): ReactElement {
  const navigate = useNavigate();
  const { activeSession } = useForecastSession();
  const forecastSessionRedirectSuppressed = useBoundStore(
    (state) => state.forecastSessionRedirectSuppressed,
  );

  useEffect(() => {
    if (
      activeSession &&
      activeSession.total_products === 0 &&
      !forecastSessionRedirectSuppressed
    ) {
      void navigate({
        to: '/configuration',
        search: { sessionId: activeSession.id },
        replace: true,
      });
    }
  }, [activeSession, forecastSessionRedirectSuppressed, navigate]);

  return <Outlet />;
}

export function ForecastPage(): ReactElement {
  return (
    <BrandSidebarWithHeader fullWidth={true}>
      <ForecastSessionGate>
        <ForecastPageContent />
      </ForecastSessionGate>
    </BrandSidebarWithHeader>
  );
}
